export default __webpack_public_path__ + "static/media/bg-gun-2.40269069.jpg";